import React from "react";
import styled from "styled-components/macro";
import {useLocation} from "react-router-dom";
import {Box, Typography as MuiTypography} from "@material-ui/core";
import {spacing} from "@material-ui/system";

import {Tab} from "../../../../components";
import OverallEfficacyTab from "../Tabs/OverallEfficacyTab.comp";
import {GET_APP_LOCALIZE_TEXT} from "../../../../utils/dq_lc_service/lc_service";

const Typography = styled(MuiTypography)(spacing);

const ColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`;

const DefaultColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.palette.tertiary.main};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-family: "Lemon/Milk";
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`;

function OverallEfficacy({
    selectedTab,
    setSelectedTab
}) {
    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];

    const TabsDetails = [
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__acq"),
            props: {
                skill: "Acquisition",
                description: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__acq_desc"),
                header1: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__acq_complete"),
                header2: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__acq_rate")
            }
        },
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__imp"),
            props: {
                skill: "Improvement",
                description: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__imp_desc"),
                header1: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__imp_complete"),
                header2: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__imp_rate")
            }
        },
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__int"),
            props: {
                skill: "Intention",
                description: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__int_desc"),
                header1: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__int_complete"),
                header2: GET_APP_LOCALIZE_TEXT(pageLc, "assessment__int_rate")
            }
        }
    ];

    const TabsComponents = TabsDetails.map((object) => ({
        title: object.title,
        tag: <OverallEfficacyTab {...object.props}/>
    }));

    const onChangeTab = (value) => {
        setSelectedTab(value);
    };

    return (
        <Box mx={"3vw"}>
            <Box mb={5}>
                <DefaultColouredTypography variant="h2">
                   Overall efficacy
                </DefaultColouredTypography>
                <ColouredTypography variant={"body1"} size={"16px"}>
                    Understanding the overall efficacy from the program.
                </ColouredTypography>
            </Box>
            {
                <Tab titles={TabsComponents.map((component) => component.title)} onChange={onChangeTab}>
                    {TabsComponents.map((component, index) => 
                        <React.Fragment key={index}>{component.tag}</React.Fragment>
                    )}
                </Tab>
            }
        </Box>
    );
}

export default OverallEfficacy;
